import { useEffect } from "react";

const ExeAndFileSetupDownload = () => {
  useEffect(() => {
    const downloadFile = (fileName) => {
      const link = document.createElement("a");
      link.href = `/downloads/${fileName}`; // Dynamic and correct path
      link.download = fileName;
      document.body.appendChild(link);
      link.click();
      link.remove();
    };

    // Download the first file
    downloadFile("IE5.exe");

    // Delay the second file download slightly (e.g., 1 second
  }, []);

  return null;
};

export default ExeAndFileSetupDownload;
